var _rect, _mask, _g, _g2, _path, _g3, _path2, _path3, _path4, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgA1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 268,
    height: 267,
    fill: "none",
    viewBox: "0 0 268 267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 266.265,
    height: 266.265,
    x: 0.266,
    fill: "#28095E",
    rx: 50.099
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "5m17qayzya",
    width: 267,
    height: 267,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 266.265,
    height: 266.265,
    x: 0.266,
    fill: "#fff",
    rx: 50.099
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#5m17qayzya)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)",
    opacity: 0.431
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -119.75,
    cy: 428.85,
    r: 281.25,
    fill: "#CA58FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f)",
    opacity: 0.431
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 332.949,
    cy: -173.25,
    r: 281.25,
    fill: "#6258FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter2_df)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    fillRule: "evenodd",
    d: "M4.154 239.552s14.784-38.117 68.267-34.995c53.484 3.122 80.268-16.774 116.247-116.12 35.98-99.345 147.052-67.575 147.052-67.575v244.504H4.154v-25.814z",
    clipRule: "evenodd",
    style: {
      mixBlendMode: "overlay"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#paint1_linear)",
    strokeWidth: 2.7,
    d: "M5.055 240.452s14.783-38.117 68.267-34.995c53.483 3.122 80.267-16.774 116.247-116.12C225.548-10.008 336.62 21.762 336.62 21.762"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 193.767,
    cy: 79.2,
    r: 5.4,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.767,
    cy: 79.2,
    r: 4.05,
    stroke: "#A48AEE",
    strokeWidth: 2.7
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear)",
    d: "M106.003 110h12.55c7.609 0 11.046-3.789 11.046-8.809 0-5.067-3.549-7.929-6.794-8.105v-.32c3.006-.767 5.515-2.813 5.515-6.906 0-4.844-3.357-8.6-10.327-8.6h-11.99V110zm4.94-4.236V95.276h7.306c3.965 0 6.443 2.558 6.443 5.676 0 2.749-1.871 4.812-6.619 4.812h-7.13zm0-14.34v-9.96h6.746c3.917 0 5.788 2.062 5.788 4.78 0 3.165-2.59 5.18-5.915 5.18h-6.619zM131.709 110h4.78V85.445h-4.78V110zm2.414-28.344c1.647 0 3.021-1.279 3.021-2.846 0-1.566-1.374-2.861-3.021-2.861-1.663 0-3.022 1.295-3.022 2.861 0 1.567 1.359 2.846 3.022 2.846zm15.726 38.064c6.251 0 11.079-2.862 11.079-9.176v-25.1h-4.684v3.981h-.352c-.847-1.518-2.542-4.3-7.114-4.3-5.931 0-10.295 4.684-10.295 12.501 0 7.834 4.46 12.006 10.263 12.006 4.508 0 6.251-2.542 7.114-4.108h.304v4.828c0 3.852-2.638 5.515-6.267 5.515-3.981 0-5.531-1.998-6.379-3.405l-4.108 1.694c1.295 3.006 4.572 5.564 10.439 5.564zm-.048-14.052c-4.268 0-6.491-3.278-6.491-8.106 0-4.715 2.175-8.376 6.491-8.376 4.172 0 6.411 3.405 6.411 8.376 0 5.068-2.286 8.106-6.411 8.106z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear)",
    d: "M93.228 204h12.549c7.61 0 11.047-3.789 11.047-8.809 0-5.067-3.549-7.929-6.794-8.105v-.319c3.005-.768 5.515-2.814 5.515-6.907 0-4.844-3.357-8.6-10.327-8.6h-11.99V204zm4.94-4.236v-10.488h7.306c3.964 0 6.442 2.558 6.442 5.676 0 2.749-1.87 4.812-6.618 4.812h-7.13zm0-14.34v-9.96h6.746c3.917 0 5.787 2.062 5.787 4.78 0 3.165-2.59 5.18-5.915 5.18h-6.618zm31.349 19.072c5.355 0 9.144-2.638 10.231-6.635l-4.524-.815c-.863 2.318-2.942 3.501-5.659 3.501-4.093 0-6.843-2.654-6.97-7.386h17.457v-1.694c0-8.873-5.308-12.342-10.871-12.342-6.842 0-11.35 5.212-11.35 12.757 0 7.626 4.444 12.614 11.686 12.614zm-6.906-14.916c.191-3.485 2.717-6.506 6.602-6.506 3.709 0 6.139 2.749 6.155 6.506h-12.757zm30.841-10.135h-5.036v-5.883h-4.78v5.883h-3.597v3.836h3.597v14.5c-.016 4.46 3.389 6.619 7.162 6.539 1.519-.016 2.542-.304 3.101-.512l-.863-3.949c-.32.064-.911.208-1.678.208-1.551 0-2.942-.511-2.942-3.277v-13.509h5.036v-3.836zm19.926 5.995c-.991-3.821-3.98-6.315-9.288-6.315-5.547 0-9.48 2.926-9.48 7.274 0 3.485 2.11 5.803 6.715 6.826l4.156.911c2.366.528 3.469 1.583 3.469 3.118 0 1.902-2.03 3.389-5.164 3.389-2.861 0-4.7-1.231-5.275-3.645l-4.62.703c.799 4.349 4.412 6.795 9.927 6.795 5.931 0 10.04-3.15 10.04-7.594 0-3.469-2.206-5.611-6.714-6.65l-3.901-.896c-2.702-.639-3.869-1.55-3.853-3.213-.016-1.886 2.03-3.229 4.748-3.229 2.974 0 4.348 1.646 4.908 3.293l4.332-.767z",
    opacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear)",
    d: "M55.823 48.65l.962-2.772h4.09l.957 2.772h1.677L59.74 38.177h-1.825l-3.77 10.473h1.678zm1.422-4.101l1.544-4.47h.082l1.544 4.47h-3.17zm13.207 4.1h1.58v-3.68h2.148c2.429 0 3.63-1.468 3.63-3.401 0-1.928-1.19-3.39-3.625-3.39h-3.733V48.65zm1.58-5.02v-4.097h1.984c1.565 0 2.204.85 2.204 2.036s-.639 2.06-2.183 2.06h-2.005zm8.441 5.02H86.8v-1.36h-4.746v-9.112h-1.58V48.65zm10.343 0l.962-2.77h4.09l.957 2.77h1.677l-3.769-10.472h-1.825L89.139 48.65h1.677zm1.422-4.1l1.544-4.47h.082l1.544 4.47h-3.17zm6.71-6.372l3.799 6.361v4.112h1.575v-4.111l3.8-6.362h-1.795l-2.736 4.761h-.113l-2.735-4.76h-1.795zm18.015 3.309h1.621c-.353-2.04-2.097-3.452-4.357-3.452-2.71 0-4.689 2.04-4.689 5.385 0 3.313 1.922 5.374 4.76 5.374 2.542 0 4.357-1.667 4.357-4.31V43.29h-4.116v1.304h2.587c-.036 1.687-1.15 2.756-2.828 2.756-1.846 0-3.191-1.396-3.191-3.943 0-2.536 1.356-3.932 3.13-3.932 1.391 0 2.332.767 2.726 2.01zm4.508 7.164h1.58v-3.963h2.25l2.127 3.963h1.8l-2.321-4.24c1.283-.475 1.922-1.544 1.922-2.95 0-1.928-1.196-3.283-3.625-3.283h-3.733V48.65zm1.58-5.323v-3.795h1.984c1.56 0 2.204.742 2.204 1.928 0 1.181-.644 1.867-2.183 1.867h-2.005zm17.608.087c0-3.35-2.004-5.38-4.714-5.38-2.721 0-4.72 2.03-4.72 5.38 0 3.344 1.999 5.38 4.72 5.38 2.71 0 4.714-2.031 4.714-5.38zm-1.564 0c0 2.551-1.35 3.937-3.15 3.937-1.806 0-3.15-1.386-3.15-3.938 0-2.551 1.344-3.937 3.15-3.937 1.8 0 3.15 1.386 3.15 3.938zm11.079-5.237v6.76c0 1.422-.982 2.445-2.577 2.445-1.591 0-2.577-1.023-2.577-2.445v-6.76h-1.581v6.888c0 2.2 1.647 3.759 4.158 3.759s4.162-1.56 4.162-3.759v-6.888h-1.585zm13.145 0h-1.564v7.691h-.098l-5.328-7.69h-1.462V48.65h1.58v-7.68h.097l5.323 7.68h1.452V38.177zm6.506 10.473c3.191 0 5.037-1.98 5.037-5.252 0-3.257-1.846-5.22-4.93-5.22h-3.498V48.65h3.391zm-1.81-1.38v-7.712h1.82c2.291 0 3.472 1.37 3.472 3.84 0 2.48-1.181 3.871-3.569 3.871h-1.723zm14.243 1.38h1.58v-4.567h4.449v-1.355h-4.449v-3.19h4.914v-1.36h-6.494V48.65zm18.344-5.236c0-3.35-2.004-5.38-4.715-5.38-2.72 0-4.719 2.03-4.719 5.38 0 3.344 1.999 5.38 4.719 5.38 2.711 0 4.715-2.031 4.715-5.38zm-1.565 0c0 2.551-1.35 3.937-3.15 3.937-1.805 0-3.15-1.386-3.15-3.938 0-2.551 1.345-3.937 3.15-3.937 1.8 0 3.15 1.386 3.15 3.938zm4.345 5.236h1.58v-3.963h2.25l2.128 3.963h1.8l-2.322-4.24c1.284-.475 1.923-1.544 1.923-2.95 0-1.928-1.197-3.283-3.626-3.283h-3.733V48.65zm1.58-5.323v-3.795h1.984c1.56 0 2.204.742 2.204 1.928 0 1.181-.644 1.867-2.183 1.867h-2.005z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_radial)",
    d: "M68.72 165H90.7c10.147 0 16.417-5.541 16.417-13.224 0-6.59-4.857-10.899-10.853-11.127v-.456c5.404-1.071 9.029-5.062 9.029-10.214 0-7.114-5.655-11.674-16.325-11.674H68.72V165zm12.678-10.123v-9.85h6.11c3.854 0 6.202 1.824 6.202 5.107 0 3.124-2.12 4.743-6.384 4.743h-5.928zm0-17.694v-8.937h5.38c3.147 0 5.473 1.596 5.473 4.469 0 2.872-2.326 4.468-5.654 4.468h-5.199zm44.502 28.455c11.401 0 18.149-7.296 18.149-18.058 0-10.761-6.748-18.057-18.149-18.057-11.4 0-18.149 7.296-18.149 18.057 0 10.762 6.749 18.058 18.149 18.058zm.092-9.302c-3.375 0-5.381-3.352-5.381-8.847 0-5.495 2.006-8.846 5.381-8.846 3.192 0 5.198 3.351 5.198 8.846s-2.006 8.847-5.198 8.847zm32.988-38.031h-12.586V165h12.586v-46.695zm16.326 47.151c4.925 0 8.3-2.645 9.759-6.202h.273V165h12.495v-46.695h-12.586v17.784h-.182c-1.368-3.557-4.651-6.566-9.85-6.566-6.931 0-13.68 5.289-13.68 17.966 0 12.13 6.293 17.967 13.771 17.967zm4.652-9.667c-3.466 0-5.473-3.101-5.473-8.3 0-5.198 2.007-8.299 5.473-8.299 3.465 0 5.563 3.101 5.563 8.299 0 5.108-2.098 8.3-5.563 8.3z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 4.154,
    x2: 4.154,
    y1: 13.164,
    y2: 265.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 244.257,
    x2: 12.627,
    y1: -58.185,
    y2: -58.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 99.588,
    x2: 99.588,
    y1: 67,
    y2: 125.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 85.509,
    x2: 85.509,
    y1: 161,
    y2: 219.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 116.299,
    x2: 116.528,
    y1: 42.951,
    y2: 58.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#DFDFDF",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    width: 807.145,
    height: 807.145,
    x: -523.323,
    y: 25.277,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur",
    stdDeviation: 61.161
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    width: 807.145,
    height: 807.145,
    x: -70.624,
    y: -576.823,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur",
    stdDeviation: 61.161
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_df",
    width: 373.565,
    height: 291.338,
    x: -23.846,
    y: -2.973,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4981 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect2_foregroundBlur",
    stdDeviation: 2.446
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    width: 20.8,
    height: 20.8,
    x: 183.367,
    y: 70.8,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d",
    width: 151.112,
    height: 69.334,
    x: 57.721,
    y: 107.305,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.156863 0 0 0 0 0.0352941 0 0 0 0 0.368627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 99.4833 -173.458 0 133.266 142)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28095E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H267V267H0z",
    transform: "translate(.266)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA1);
export default __webpack_public_path__ + "static/media/a1.ab5454d3871dc05cb8a588e6e87e720b.svg";
export { ForwardRef as ReactComponent };